import { TopLevelFormatterParams } from 'echarts/types/dist/shared';
import { isArray, isNumber } from 'lodash';
import { UTCDate } from '@date-fns/utc';
import { format } from 'date-fns';
import { DEFAULT_DATE_TIME_FORMAT_WITHOUT_ZONE, getComputerFormattedTime } from '../../../../domain/date/date';
import { PRIMARY_COLOR } from '../../../../theme';

export function renderTooltip(params: TopLevelFormatterParams) {
    if (!isArray(params)) return '';

    const usageSeries = params.find(item => item.seriesName?.includes('Usage'));
    const baselineSeries = params.find(item => item.seriesName?.includes('Baseline'));
    const performanceSeries = params.find(item => item.seriesName?.includes('Performance'));
    const consumptionSeries = params.find(item => item.seriesName?.includes('Consumption'));

    if (!usageSeries && !baselineSeries && !performanceSeries && !consumptionSeries) return '';

    const paramWithTimestamp = params.find(item => isArray(item.value) && item.value[0]);
    const timestamp = paramWithTimestamp && isArray(paramWithTimestamp.value) ? paramWithTimestamp.value[0] : null;

    const usageKw = isArray(usageSeries?.value) ? usageSeries?.value[1] : null;
    const baselineKw = isArray(baselineSeries?.value) ? baselineSeries?.value[1] : null;
    const performanceKw = isArray(performanceSeries?.value) ? performanceSeries?.value[1] : null;
    const consumptionKwh = isArray(consumptionSeries?.value) ? consumptionSeries?.value[1] : null;

    const dateElement = isNumber(timestamp)
        ? `<div style='text-align: center; color: #697475; padding: 0 10px;'>${format(new UTCDate(+timestamp), DEFAULT_DATE_TIME_FORMAT_WITHOUT_ZONE)} ${getComputerFormattedTime(new Date(), 'zzz')}</div>`
        : '';
    const dividerElement = `<div style='margin: 10px 0 10px 0; height: 1px; border-bottom: 1px solid #f0f0f0;'></div>`;

    return `<div style='padding: 10px 0; margin: 0;'>
                ${dateElement}
                ${dividerElement}
                ${isNumber(usageKw) ? makeSeriesElement('Usage', PRIMARY_COLOR, 'solid', usageKw, 'kW') : ''}
                ${isNumber(consumptionKwh) ? makeSeriesElement('Energy Consumption', PRIMARY_COLOR, 'solid', consumptionKwh, 'kWh') : ''}
                ${isNumber(baselineKw) ? makeSeriesElement('Estimated Baseline', '#4A7088', 'solid', baselineKw, 'kW') : ''}
                ${isNumber(performanceKw) ? makeSeriesElement('Estimated Performance', '#CE7553', 'solid', performanceKw, 'kW') : ''}
            </div>`;
}

function makeSeriesElement(name: string, color: string, style: 'dashed' | 'solid', value: any, uom: 'kW' | 'kWh') {
    const shouldFormatValue = isNumber(value) && !isNaN(value);
    const formattedValue = shouldFormatValue ? new Intl.NumberFormat('en-EN').format(Math.round(value * 100) / 100) : 'N/A';

    return `<div style='padding: 0 10px; display: flex; justify-content: space-between; color: #2e3838; font-size: 14px; font-weight: 400'>
                    <div style='display: flex; justify-content: center; align-items: center; padding-right: 8px' >
                        <span style='display: inline-block; width: 20px; line-height: 14px; border-bottom: 4px ${style} ${color}'></span> 
                        <span style='padding-left: 4px'>${name}:</span>
                    </div>
                    <div style='align-self: flex-end'>${formattedValue} ${uom}</div>
                </div>`;
}
